import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { toRefs } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRouter } from 'vue-router';
import type { Nullable } from '@/modules/shared/types/index.type';
import MessageBox from '@/modules/shared/components/molecules/messageBox/MessageBox.vue';

interface EmptySearchProps {
  keyword?: Nullable<string>;
  onClearSearch?: () => (void | Promise<void>);
  dataTest?: Nullable<string>;
  isShowOnClearButton?: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'EmptySearch',
  props: {
    keyword: {},
    onClearSearch: {},
    dataTest: { default: 'empty-search-container' },
    isShowOnClearButton: { type: Boolean, default: true }
  },
  setup(__props: any) {

const props = __props;

const {
  keyword,
  onClearSearch,
  dataTest,
} = toRefs(props);

const { t } = useI18n();
const router = useRouter();

const onClickClearSearch = () => {
  router.push({ query: undefined });

  if (onClearSearch.value) {
    onClearSearch.value();
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(MessageBox, {
    iconClassName: "fas fa-search",
    title: _unref(keyword) ? _unref(t)('common:search.resultEmpty.title', { q: _unref(keyword) }) : _unref(t)('common:search.resultEmpty.title_noSearchKeyword'),
    description: _unref(keyword) ? _unref(t)('common:search.resultEmpty.description') : _unref(t)('common:search.resultEmpty.description_noSearchKeyword'),
    buttonTitle: _ctx.isShowOnClearButton ? _unref(t)('common:search.resultEmpty.buttonTitle') : '',
    onClickButton: onClickClearSearch,
    dataTest: _unref(dataTest)
  }, null, 8, ["title", "description", "buttonTitle", "dataTest"]))
}
}

})